export const SOLVIS_LOCATION_LIST: string = import.meta.env.VITE_ANALYSIS_LOC_LIST_ID || "NZ";
export const SOLVIS_RADII_ID: number = Number(import.meta.env.VITE_RADII_ID) || 6;
export const TOSHI_LINK: string =
  import.meta.env.VITE_TOSHI_LINK || "http://simple-toshi-ui.s3-website-ap-southeast-2.amazonaws.com";
export const SEARCH_INDEX: string = import.meta.env.VITE_SEARCH_INDEX || "toshi_index";
export const ES_ENDPOINT: string = import.meta.env.VITE_ES_ENDPOINT || "http://localhost:9200";
export const API_KEY: string = import.meta.env.VITE_GRAPHQL_API_KEY || "env.VITE_GRAPHQL_API_KEY is undefined";
export const REPORT_URL: string =
  import.meta.env.VITE_REPORTS_URL ||
  "http://nzshm22-static-reports.s3-website-ap-southeast-2.amazonaws.com/opensha/DATA";

export const TOSHI_TYPES: string[] = import.meta.env.VITE_TOSHI_TYPES || [
  "File",
  "RuptureGenerationTask",
  "RuptureSet",
  "StrongMotionStation",
  "SmsFile",
  "GeneralTask",
  "Table",
  "InversionSolution",
  "AutomationTask",
  "ScaledInversionSolution",
  "TimeDependentInversionSolution",
  "AggregateInversionSolution",
  "OpenquakeHazardTask",
  "OpenquakeHazardSolution",
  "InversionSolutionNrml",
  "OpenquakeHazardConfig",
];
